import { ProviderType } from './types'

export const OAuthRedirectUri = {
  [ProviderType.BIGQUERY]: 'connections/bigquery/oauth',
  [ProviderType.SNOWFLAKE]: 'connections/oauth/snowflake/callback',
  [ProviderType.DATABRICKS_REST]: 'connections/oauth/databricks/callback'
}

export const REDIRECT_URI = 'redirect_uri'
